module.exports = fox._r("images/promo/close-menu-arr.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/close-menu-arr.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/close-menu-arr.png
// module id = 179
// module chunks = 2